module.exports = __webpack_public_path__ + "img/syrah.428e1967.jpg";